<template>
  <div class="flex flex-col items-center mx-auto mt-[90px] mb-[200px] w-[421px]">
    <div class="text-center">
      <Resource
        :src="getFeUrl('/youyan-platform/png/no-search-data.png')"
        :transform-resource="transformImage"
        class="w-[88px] h-[86px]"
      />
    </div>
    <div class="mt-[24px] text-font-80">
      {{ $t('wei-zhao-dao-xiang-guan-nei-rong-nin-ke-yi-chang-shi-jing-jian-guan-jian-ci-huo') }}
      <el-button
        type="link"
        class="text-primary truncate cursor-pointer"
        @click="handleOpenCustomerService"
      >
        {{ $t('lian-xi-ke-fu').toLocaleLowerCase() }}
      </el-button>
      {{ $t('chu-li') }}
    </div>
    <div v-if="list.length" class="mt-[20px] flex items-center justify-between">
      <Popular
        class="flex-1 justify-center"
        position="empty"
        :list="list"
        source="empty"
        @select="selectTag"
      />
      <a
        class="flex-y-center cursor-pointer gap-[4px] text-14 text-font-60 hover:text-primary ml-[6px]"
        @click="emits('refresh')"
      >
        <iconpark-icon name="arrow-refresh" />{{ $t('huan-yi-huan') }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import Popular from '@/features/searchInput/popular.vue';
defineProps({
  list: {
    type: Array<string>,
    default: () => [],
  },
});

const emits = defineEmits(['select', 'refresh', 'openCustomerService']);

const handleOpenCustomerService = () => {
  emits('openCustomerService');
  openCustomerService();
};

const selectTag = (val: string) => {
  emits('select', val);
};
</script>
